import { render, staticRenderFns } from "./ItemListHoldingLayout.vue?vue&type=template&id=7ff69172&scoped=true"
import script from "./ItemListHoldingLayout.vue?vue&type=script&lang=js"
export * from "./ItemListHoldingLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff69172",
  null
  
)

export default component.exports